<div class="component ps-2 pe-2" [class.text-center]="centerText" [style.backgroundColor]="backgroundColor" [style.color]="color"
     [class.p-2]="!compact" [class.compact]="compact">
    <ng-content></ng-content>&nbsp;
</div>
